import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import {
  resultGetone,
  approveRejectResult,
} from "../../Redux/Slices/resultSlice";
import { Image } from "primereact/image";
import RejectModal from '../../Components/RejectModal';
import toast from 'react-hot-toast';

const EditResultNotification = () => {
  const { id } = useParams();
  const location = useLocation();
  const isRejected = location.state?.isRejected;
  const notificationType = location.state?.notificationType;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);

  const initialValues = {
    profileImage: null,
    સભ્યની_અટક: "",
    સભ્યનું_નામ: "",
    સભ્યના_પિતા_નું_નામ: "",
    માધ્યમ: "",
    સભ્યનું_ભણતર: "",
    ટકાવારી: "",
    મેળવેલ_ગુણ: "",
    remark: allData?.remark || "",
  };

  const fetchUserData = async () => {
    if (id) {
      const payload = { resultId: id };
      try {
        const res = await dispatch(resultGetone(payload)).unwrap();
        if (res.IsSuccess) {
          setAllData(res?.Data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const acceptRequest = async (resultid) => {
    try {
      setLoading(true);
      await dispatch(
        approveRejectResult({
          resultId: resultid || "",
          action: "approved",
        }),
      ).unwrap();
      await fetchUserData();
      setLoading(false);
      navigate('/result-notification', { state: { notificationType } });
    } catch (error) {
      setLoading(false);
      console.log("error :>> ", error);
    }
  };

  const rejectRequest = async (remark) => {
    try {
      setLoading(true);
      await dispatch(approveRejectResult({
        resultId: id || "",
        remark: remark || "",
        action: "rejected"
      })).unwrap();
      await fetchUserData();
      setLoading(false);
      setIsRejectModalOpen(false);
      toast.success("Result rejected successfully");
      navigate('/result-notification', { state: { notificationType } });
    } catch (error) {
      setLoading(false);
      console.log("error :>> ", error);
      toast.error("Failed to reject result");
    }
  }

  const handleDownload = (coupen) => {
    if (coupen) {
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);
      a.href = coupen;
      a.target = "_blank";
      a.download = coupen;
      a.click(); // Trigger the download
      window.URL.revokeObjectURL(coupen); // Clean up the Blob URL
      a.remove();
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [id]);
  return (
    <>
      <div className="bg-gray-50">
        <div className=" mx-aut0">
          <div className="bg-white rounded-lg shadow p-9">
            <div className="py-2 lg:py-4 flex flex-wrap items-center">
              <button
                onClick={() => navigate('/result-notification', { state: { notificationType } })}
                className="flex items-center text-gray_2"
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
            </div>
            <div className="flex flex-wrap justify-between items-center pb-6 xl:space-y-0 space-y-3">
              <div className="flex items-center space-x-4">
                {allData?.profile_pic ? (
                  <img
                    className="h-12 lg:h-16 w-12 lg:w-16 rounded-full object-cover"
                    src={allData?.profile_pic}
                    alt="Profile"
                  />
                ) : (
                  <div className="h-12 lg:h-16 w-12 lg:w-16 rounded-full bg-gray-200 flex items-center justify-center text-xs text-gray-500 border border-gray-300">
                    No Image
                  </div>
                )}
                <div className="flex flex-col">
                  <h2 className="text-16 lg:text-24 font-semibold text-text_1">
                    {allData?.familymember?.surname}{" "}
                    {allData?.familymember?.name}{" "}
                    {allData?.familymember?.fathername}
                    {/* <span className="text-14 text-green bg-[#E7FAF0] rounded-lg py-1 lg:py-2 px-2.5 lg:px-4 ml-5">Active</span> */}
                  </h2>
                  <span className="block text-sm text-gray-500">
                    {allData?.user?.mobile}
                  </span>
                </div>
              </div>

              {allData?.action === "pending" ? (
                <div className="flex space-x-3">
                  <button
                    onClick={() => acceptRequest(allData?._id)}
                    className="btn"
                  >
                    Accept
                  </button>
                  <button
                    onClick={() => setIsRejectModalOpen(true)}
                    className="px-4 py-2 bg-red hover:bg-white hover:text-red border hover:border-red text-white font-medium rounded-md anim"
                  >
                    Reject
                  </button>
                </div>
              ) : (
                ""
              )}

              {allData?.action === "approved" && allData?.coupen ? (
                <div className="flex space-x-3">
                  <button
                    onClick={() => handleDownload(allData?.coupen)}
                    className="btn"
                  >
                    Download
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="shadow-custom_shadow rounded-[20px] p-9">
              <h2 className="text-18 font-semibold text-gray_2 border-b border-gray_2 pb-6">
                Result Details
              </h2>
              <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={async (values) => {
                  try {
                    setLoading(true);
                    await dispatch(approveRejectResult({
                      resultId: id || "",
                      remark: values.remark || "",
                      action: "rejected"
                    })).unwrap();
                    await fetchUserData();
                    setLoading(false);
                    toast.success("Result remark updated successfully");
                    navigate('/result-notification', { state: { notificationType } });
                  } catch (error) {
                    setLoading(false);
                    toast.error("Failed to update result remark");
                  }
                }}
              >
                {({ values }) => (
                  <Form className="pt-6">
                    <div className="flex gap-6">
                      {/* Left side: all fields in 2 columns */}
                      <div className="flex-1 grid grid-cols-2 gap-x-6 gap-y-3">

                        <div className="w-full">
                          <label className="block text-sm font-medium text-text_1 mb-1">
                            સભ્યની અટક
                          </label>
                          <Field
                            name="સભ્યનુ_અટક"
                            className="w-full p-2 border border-gray-300 rounded-md"
                            placeholder="સભ્યની અટક"
                            value={allData?.familymember?.surname}
                            disabled
                          />
                        </div>

                        <div className="w-full">
                          <label className="block text-sm font-medium text-text_1 mb-1">
                            સભ્યનું નામ
                          </label>
                          <Field
                            name="સભ્યનું_નામ"
                            className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                            placeholder="સભ્યનું નામ"
                            value={allData?.familymember?.name}
                            disabled
                          />
                        </div>

                        <div className="w-full">
                          <label className="block text-sm font-medium text-text_1 mb-1">
                            સભ્યના પિતા નું નામ
                          </label>
                          <Field
                            name="સભ્યના_પિતા_નું_નામ"
                            className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                            placeholder="સભ્યના પિતા નું નામ"
                            value={allData?.familymember?.fathername}
                            disabled
                          />
                        </div>

                        <div className="w-full">
                          <label className="block text-sm font-medium text-text_1 mb-1">
                            માધ્યમ
                          </label>
                          <Field
                            name="માધ્યમ"
                            className="w-full p-2 border border-gray-300 rounded-md"
                            placeholder="માધ્યમ"
                            value={allData?.medium}
                            disabled
                          />
                        </div>

                        <div className="w-full">
                          <label className="block text-sm font-medium text-text_1 mb-1">
                            સભ્યનું ભણતર
                          </label>
                          <Field
                            name="સભ્યનું_ભણતર"
                            className="w-full p-2 border border-gray-300 rounded-md"
                            placeholder="સભ્યનું ભણતર" l
                            value={allData?.education?.gujarati_name}
                            disabled
                          />
                        </div>

                        <div className="w-full">
                          <label className="block text-sm font-medium text-text_1 mb-1">
                            ટકાવારી (%)
                          </label>
                          <Field
                            name="ટકાવારી"
                            className="w-full p-2 border border-gray-300 rounded-md"
                            placeholder="ટકાવારી (%)"
                            value={allData?.percentage}
                            disabled
                          />
                        </div>

                        {/* <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    મેળવેલ ગુણ
                                                </label>
                                                <Field
                                                    name="મેળવેલ_ગુણ"
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder="મેળવેલ ગુણ"
                                                    disabled
                                                />
                                            </div> */}

                        {isRejected && (
                          <div className="w-full">
                            <label className="block text-sm font-medium text-text_1 mb-1">
                              રિમાર્ક
                            </label>
                            <Field
                              name="remark"
                              className="w-full p-2 border border-gray-300 rounded-md"
                              placeholder="રિમાર્ક"
                            />
                          </div>
                        )}
                      </div>

                      {/* Right side: image */}
                      <div className="w-48 flex flex-col flex-shrink-0">
                        <label className="block text-sm font-medium text-text_1 mb-1 cursor-pointer">
                          પરિણામ ફોટો
                        </label>
                        <div className="input flex-grow border-dashed border border-primary flex flex-col items-center justify-center cursor-pointer overflow-hidden rounded bg-gray-50 p-2">
                          {allData?.result ? (
                            <Image
                              src={allData.result}
                              alt="Result"
                              className="w-full h-full object-contain"
                              preview={true}
                            />
                          ) : (
                            <>
                              <span className="icon-export text-18 2xl:text-[20px] text-b1 inline-block"></span>
                              <span className="inline-block text-14 2xl:text-16 text-b1 mt-1 text-center">
                                No Image Available
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {isRejected && (
                      <div className="flex justify-center mt-6">
                        <button type="submit" disabled={loading} className="px-10 py-2 bg-green text-white font-medium rounded-md hover:bg-white hover:text-green transition-colors border border-transparent hover:border-green">
                          {loading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    )}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <RejectModal
        isOpen={isRejectModalOpen}
        onClose={() => setIsRejectModalOpen(false)}
        onConfirm={rejectRequest}
        loading={loading}
      />
    </>
  );
};

export default EditResultNotification;
